import { DISMISS_PREFIX } from './constants.js'

function dismissStorageKey(remoteKey) {
  return `${DISMISS_PREFIX}:${remoteKey}`
}

export function isUpdateDismissed(remoteKey) {
  if (typeof window === 'undefined' || !remoteKey) return false
  try {
    return sessionStorage.getItem(dismissStorageKey(remoteKey)) === '1'
  } catch {
    return false
  }
}

export function dismissUpdate(remoteKey) {
  if (typeof window === 'undefined' || !remoteKey) return
  try {
    sessionStorage.setItem(dismissStorageKey(remoteKey), '1')
  } catch {
    /* private mode / quota */
  }
}
